import { Grid, Typography } from '@mui/material'
import dayjs from 'dayjs'
import PropTypes from 'prop-types'
import * as React from 'react'
import { useSelector } from 'react-redux'
import { getSoIdNumber } from '../../../../../helpers'
import { selectActiveHours } from '../../../../../store/redusers/assets/selectors'


function SidebarInfoTrendingHours({assetInfo}) {
	const activeHours = useSelector(selectActiveHours(getSoIdNumber(assetInfo.assetSoId)))
	return (
		<Grid container sx={{ borderTop: '1px solid #F6F7F9', mt: 4, pt: 2 }}>
			{activeHours.map((d, index) => {
				return (<>
					<Grid key={index} item sx={{ p: 2 }} xs={6}>
						<Typography
							fontSize={'18px'}
							fontWeight={'bold'}
						>
							{dayjs.unix(d.startTime).format('dddd')}
						</Typography>
					</Grid>
					<Grid item sx={{ p: 2 }} xs={6}>
						<Typography fontSize={'18px'} fontWeight={'bold'}>
							{dayjs.unix(d.startTime).format('HH:mm') + '-' + dayjs.unix(d.endTime).format('HH:mm')}
						</Typography>
					</Grid>
				</>)
			})
			}
		</Grid >
	)
}
SidebarInfoTrendingHours.propTypes = {
	assetInfo: PropTypes.object
}
export default SidebarInfoTrendingHours
